module.exports = __webpack_public_path__ + "img/scree-share-win.14ff8e54.png";